import { IMajorMilestoneProjectTypeVisibility } from '../../interfaces/imajor-milestone-project-type-visibility';
import { MajorMilestone } from '../major-milestone';
import { ProjectType } from '../project-type';

export class MajorMilestoneProjectTypeVisibilityBase {
  MajorMilestoneProjectTypeVisibilityId: number;
  MajorMilestoneId: number;
  ProjectTypeId: number;
  SortOrder: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  MajorMilestone?: MajorMilestone;
  ProjectType?: ProjectType;

  constructor(item?: IMajorMilestoneProjectTypeVisibility) {
    if (item) {

      this.MajorMilestoneProjectTypeVisibilityId = item.MajorMilestoneProjectTypeVisibilityId;
      this.MajorMilestoneId = item.MajorMilestoneId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.MajorMilestone = new MajorMilestone(item.MajorMilestone);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}